import { isAxiosError } from 'axios';
import { OAuthClientRegistrationError } from '@/services/partner-token-exchange.types';

const errorCodeByMessage = Object.fromEntries(
  Object.entries(OAuthClientRegistrationError).map(([code, message]) => [
    message,
    code,
  ]),
) as Record<
  OAuthClientRegistrationError,
  keyof typeof OAuthClientRegistrationError
>;

/**
 * The endpoint reports validation failures as a plain message — either as the
 * response body itself or in its `message` field.
 */
const readResponseMessage = (error: unknown): string | undefined => {
  if (isAxiosError<string | { message?: string }>(error)) {
    const data = error.response?.data;

    return typeof data === 'string' ? data : data?.message;
  }

  return undefined;
};

/**
 * Translation context for a failed registration — undefined when the failure
 * is not one of the known validation messages, so the caller falls back to its
 * generic message.
 */
export const resolveClientRegistrationErrorCode = (
  error: unknown,
): keyof typeof OAuthClientRegistrationError | undefined => {
  const message = readResponseMessage(error)?.trim();

  return message
    ? errorCodeByMessage[message as OAuthClientRegistrationError]
    : undefined;
};
